/**
import { getFirstLastName } from '@/utils';
 * Formatar o CPF numerico em 000.000.000-00
 * @param value
 */
export function formatCPFFilter(value: any) {
	if (!value) return '-'

	let cpf = value.toString()
	while (cpf.toString().length < 11) {
		cpf = '0' + cpf
	}

	return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

/**
 * Retorna primeiro nome
 * @param value
 */
export function getFirstName(value: string) {
	if (value) {
		let nome = value.substring(0, value.indexOf(' '))
		return nome
	}

	return ''
}

/**
 * Retorna ultimo nome
 * @param value
 */
export function getLastName(value: string) {
    return value ? value.substring(value.lastIndexOf(' ') + 1) : ''
}

/**
 * Retorna um nome abreviado
 * @param value
 */
export function AbreviacaoFilter(value: string | undefined) {
	function abreviacao(s: string) {
		return /^([A-Z]\.)+$/.test(s)
	}

	function numeralRomano(s: string) {
		return /^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/.test(s)
	}

	function capitalize(texto: string) {
		let prepos = ['da', 'do', 'das', 'dos', 'a', 'e', 'de']
		return texto
			.split(' ') // quebra o texto em palavras
			.map((palavra) => {
				// para cada palavra
				if (abreviacao(palavra) || numeralRomano(palavra)) {
					return palavra
				}

				palavra = palavra.toLowerCase()
				if (prepos.includes(palavra)) {
					return palavra
				}
				return palavra.charAt(0).toUpperCase() + palavra.slice(1)
			})
			.join(' ') // junta as palavras novamente
	}

	return !!value ? capitalize(value) : value
}

/**
 * Pega o primeiro e segundo nome do usuario
 * @param fullName // nome completo
 * @param limit // limite de caracteres para abreviar
 */

export function getFirstLastName(fullName: any, limit: any) {
	if (fullName.length > limit) {
		return toAbridged(fullName)
	}
	return fullName
}

function toAbridged(fullName: any) {
	const token = '.'
	const separator = ' '
	const names = removePrepositions(fullName).split(separator)
	const firstName = names[0]
	let surnames = ''
	names.filter((name: any, index: any) => index).map((name: any) => (surnames += `${separator}${name.charAt()}${token}`))
	return `${firstName}${surnames.toUpperCase()}`
}

function removePrepositions(fullName: any) {
	return fullName.replace(/\ dos|\ das|\ dos|\ das|\ de|\ d\'/gi, '')
}

/**
 * Remove os acentos e cedilha de um texto
 * @param txt
 */
export function limparAcentosFilter(txt: string) {
	return txt
		.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
		.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
		.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
		.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
		.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
		.replace(new RegExp('[Ç]', 'gi'), 'c')
}

/**
 * Retorna a quantidade com o seu plural
 * Exemplo: 2 usuarios || 1 usuário || nenhum
 * @param count
 * @param word
 * @param plural
 */
export function pluralize(count: number, word: string, plural: string) {
	if (count == 0) return 'Nenhum'
	return `${count} ${count > 1 ? plural : word}`
}

export function fileSize(bytes: number, decimals: number = 2, space: string = '') {
	decimals = 'number' === typeof decimals ? decimals : 2
	space = 'string' === typeof space ? space : ''

	var size = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
		factor = Math.floor((String(bytes).length - 1) / 3)

	bytes = bytes / Math.pow(1024, factor) //calc
	bytes = Math.floor(bytes * Math.pow(10, decimals)) / Math.pow(10, decimals) //round digits

	return String(bytes) + space + size[factor]
}

export function formatCelularTelefoneFilter(numero: string) {
	var numeroFormatado
	if (numero === null) {
		return '-'
	}
	numero = numero.replace(/\D/g, '')
	if (numero.length == 10) {
		numeroFormatado = numero.replace(/(\d{2})(\d{4})/, '($1) $2-')
	} else if (numero.length > 10) {
		numeroFormatado = numero.replace(/(\d{2})(\d{5})/, '($1) $2-')
	} else numeroFormatado = numero
	return numeroFormatado
}

export function removeTagsFromText(text: string) {
	return text.replace(/(<([^>]+)>)/gi, '')
}

export function fileFormat(file: string) {
	switch (file) {
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return '.xlsx'
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return '.docx'
		case 'application/pdf':
			return '.pdf'
		case 'application/msword':
			return '.doc'
		case 'application/vnd.ms-excel':
			return '.xls'
		case 'application/vnd.ms-powerpoint':
			return '.ppt'		
		default:
			return file
	}
}
